// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const alphaottColors: ColorType = { ...colorPalette }

export const lightTheme = {
  colors: alphaottColors,
  background: {
    primary: '#fafafa',
    secondary: '#fafafa',
    highlight: alphaottColors.light,
    select: '#fafafa',
    footerTop: '#eee',
  },
  text: {
    primary: alphaottColors.dark,
    secondary: alphaottColors.grayText,
    disabled: alphaottColors.dark,
    link: alphaottColors.dark,
    hint: alphaottColors.dark,
    highlight: alphaottColors.primary,
    gray: alphaottColors.grayText,
    seeAll: 'rgba(52, 73, 94, 0.8)',
    primaryContrast: '#ffffff',
  },
  border: {
    primary: '#dddddd',
    gray: '#ddd',
  },
  filter: {
    primary: '#43484d',
    secondary: '#43484d',
    disabled: alphaottColors.grayLabel,
    highlight: '#fff',
  },
  tabs: {
    bg: '#fafafa',
    containerBg: alphaottColors.dark,
    color: alphaottColors.dark,
    border: alphaottColors.primary,
    scrollbarThumb: alphaottColors.primary,
    programTitle: alphaottColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: 'rgba(221, 221, 221, 0.8)',
        hover: alphaottColors.dark,
        selected: alphaottColors.dark,
        progress: rgba(alphaottColors.primary, 0.3),
        past: rgba(alphaottColors.primary, 0.3),
        pastSelected: alphaottColors.dark,
        pastHover: alphaottColors.dark,
        empty: 'rgba(221, 221, 221, 0.3)',
        emptyProgress: rgba(alphaottColors.primary, 0.1),
      },
      text: {
        empty: alphaottColors.grayLabel,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #fafafa 0%,${rgba('#fafafa', 0.97)} 13.03%,${rgba('#fafafa', 0.69)} 43.24%,${rgba(
          '#fafafa',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0,#fafafa 0%,${rgba('#fafafa', 0.73)} 34.97%,${rgba('#fafafa', 0)} 100%);`,
    },
  },
  card: {
    title: alphaottColors.dark,
    subTitle: alphaottColors.grayText,
    bg: alphaottColors.dark,
    number: alphaottColors.grayBorder,
    boxShadow: 'rgba(221, 221, 221, 0.8)',
    loaderBackgroundImage: 'linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%)',
  },
  dimension: {},
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
